<template>
  <MainLayout>
    <b-row id="analyses">
      <b-col class="shadow-sm">
        <h4 class="card-title font-weight-bold">
          Verwendungs-Daten als Excel exportieren
        </h4>

        <b-card-body>
          <b-row>
            <AnalysesManagment class="w-100" />
          </b-row>
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import AnalysesManagment from "@/components/analyses/AnalysesManagement.vue";
export default {
  components: {
    MainLayout,
    AnalysesManagment,
  },
};
</script>

<style></style>
